import { styled as muiStyled } from '@mui/material'

export const CoolMultiCardCarouselCardItemContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    font-size: 18px;
    gap: 14px;
    background: #fff;
    max-width: 500px;
    margin: 0 auto;
    text-align :center;
    border-radius: 14px;
    .heading {
        font-size: 1em;
        font-weight: 700;
        text-transform: uppercase;
        color: #6655ab;
    }
    .sub-heading {
        font-size: 0.85em;
        font-weight: 800;
        
    }
    .description {
        font-size: 0.7em;
        font-weight: 300;
        text-align: left;
    }
    
    @media(min-width: 768px){
        max-width: unset;
        margin: unset;
    // aspect-ratio: 9/16;
}
    @media(min-width: 996px){
        font-size: 18px;
        padding: 10px 20px;
    }
    @media(min-width: 1200px){
        font-size: 18px;
        padding: 20px 40px;
    }
`,
)
